import { IExportColumnModel } from "../../../../shared/models";

export const ExtractionSchedulingRecipesColumnList: IExportColumnModel[] = [
]